// extracted by mini-css-extract-plugin
export default {"tableSection":"it-approval-page_tableSection__C9rIR","iconBtn":"it-approval-page_iconBtn__URuf2","queueFilters":"it-approval-page_queueFilters__J5HyN"};